module.exports = __webpack_public_path__ + "static/media/14UNEP20.68d049ab.jpg";